module.exports = __webpack_public_path__ + "static/media/filterizr-logo.f5573e1e.png";